module.exports = __webpack_public_path__ + "img/Honig-aus-2021-980.e7065efa.jpg";